// src/AssetManager/ConfirmDeleteDialog.jsx
import * as React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Typography,
  Box,
  Button,
} from '@mui/material';

export default function ConfirmDeleteDialog({
  open,
  onClose,
  onConfirm,
  asset,
  busy = false,
}) {
  const name = asset?.name || '—';
  const ver =
    typeof asset?.versionNumber === 'number' ? `v${asset.versionNumber}` : '—';

  return (
    <Dialog
      open={open}
      onClose={() => !busy && onClose?.()}
      aria-labelledby="asset-delete-dialog-title"
      aria-describedby="asset-delete-dialog-description"
      fullWidth
      maxWidth="xs"
    >
      <DialogTitle id="asset-delete-dialog-title">
        Delete asset and all versions?
      </DialogTitle>

      <DialogContent dividers>
        <DialogContentText id="asset-delete-dialog-description">
          You’re about to permanently delete this file — including all versions
          and related data. This action cannot be undone.
        </DialogContentText>

        <Box sx={{ mt: 1 }}>
          <Typography variant="body2" color="text.secondary">
            <strong>Name:</strong> {name}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            <strong>Version:</strong> {ver}
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 2, py: 1.5 }}>
        <Button
          onClick={onClose}
          disabled={busy}
          variant="outlined"
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
          disableElevation
          disabled={busy}
        >
          {busy ? 'Deleting…' : 'Delete'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ConfirmDeleteDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  asset: PropTypes.object,
  busy: PropTypes.bool,
};
